// @flow
import React from 'react';

export const VideoRenderFloatingContext = React.createContext<any>();
